var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      key: _vm.stateChangeKey,
      attrs: { id: "mfa-otp-form" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          _vm.handleSubmit(_vm.otpDigits.join(""))
        }
      }
    },
    [
      _c("div", { staticClass: "w-100 mt-3 mb-4 text-center" }, [
        _c(
          "div",
          { staticClass: "otp-inputs" },
          _vm._l(_vm.length, function(_digit, idx) {
            return _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.otpDigits[idx],
                  expression: "otpDigits[idx]"
                }
              ],
              key: idx,
              ref: "otpInput" + idx,
              refInFor: true,
              class: { error: _vm.hasError },
              attrs: {
                type: "text",
                pattern: "[0-9]*",
                inputmode: "numeric",
                maxlength: "1",
                placeholder: _vm.placeholder
              },
              domProps: { value: _vm.otpDigits[idx] },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.otpDigits, idx, $event.target.value)
                  },
                  function($event) {
                    return _vm.onOTPInput(idx)
                  }
                ],
                keydown: function($event) {
                  return _vm.onOTPKeydown($event, idx)
                },
                paste: function($event) {
                  return _vm.handlePaste($event)
                },
                change: function($event) {
                  return _vm.$emit("resetErrors")
                }
              }
            })
          }),
          0
        ),
        _vm._v(" "),
        _vm.hasError || _vm.warning
          ? _c("div", { staticClass: "w-100 para-3 error-text" }, [
              _vm.hasError
                ? _c("span", { staticClass: "text-bold error-message" }, [
                    _c("i"),
                    _vm._v(_vm._s(_vm.error[0]))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.warning
                ? _c("span", { style: { color: _vm.warningColor } }, [
                    _vm.hasError ? _c("br") : _vm._e(),
                    _c("i"),
                    _vm._v(_vm._s(_vm.warning))
                  ])
                : _vm._e()
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "AppButton",
        {
          staticClass: "w-100 mb-2",
          attrs: {
            name: _vm.submitButtonName,
            disabled: !_vm.otpFilled || _vm.isLoading,
            loading: _vm.isLoading,
            type: "submit",
            size: "medium",
            "data-target": _vm.dataTarget
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.submitButtonText) + "\n\t")]
      ),
      _vm._v(" "),
      _vm.showHelpAndRecovery
        ? _c("div", { staticClass: "help-section" }, [
            _c("p", { staticClass: "modal-pretext text-light text-center" }, [
              _vm._v("\n\t\t\tLost access? "),
              _c(
                "a",
                {
                  staticClass: "button-color",
                  on: { click: _vm.openRecoveryInputModal }
                },
                [_vm._v("Use a backup code")]
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "modal-pretext text-light text-center" }, [
              _vm._v("Or "),
              _c(
                "a",
                {
                  staticClass: "button-color",
                  on: { click: _vm.openHelpPageInNewTab }
                },
                [_vm._v("get help")]
              )
            ])
          ])
        : _c(
            "AppButton",
            {
              staticClass: "w-100",
              attrs: {
                name: _vm.helpButtonName,
                size: "medium",
                type: "button",
                link: ""
              },
              on: { click: _vm.openHelpPageInNewTab }
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.helpButtonText) + "\n\t")]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }